import { ethers } from 'ethers';

const SMART_CONTRACT_ADDRESS = '0xFD6202f89fAaA8fBB44A448bB5c727BeC70fD49D';
const SMART_CONTRACT_ABI = [
  {
    "inputs": [{ "internalType": "string", "name": "trackId", "type": "string" }],
    "name": "logTrackAccess",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [{ "internalType": "string", "name": "trackId", "type": "string" }],
    "name": "logTrackCreation",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": true, "internalType": "address", "name": "user", "type": "address" },
      { "indexed": false, "internalType": "string", "name": "trackId", "type": "string" },
      { "indexed": false, "internalType": "uint256", "name": "timestamp", "type": "uint256" }
    ],
    "name": "TrackAccessed",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": true, "internalType": "address", "name": "creator", "type": "address" },
      { "indexed": false, "internalType": "string", "name": "trackId", "type": "string" },
      { "indexed": false, "internalType": "uint256", "name": "timestamp", "type": "uint256" }
    ],
    "name": "TrackCreated",
    "type": "event"
  },
  {
    "inputs": [{ "internalType": "string", "name": "trackId", "type": "string" }],
    "name": "getTrackInfo",
    "outputs": [
      { "internalType": "address", "name": "creator", "type": "address" },
      { "internalType": "uint256", "name": "timestamp", "type": "uint256" }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [{ "internalType": "string", "name": "trackId", "type": "string" }],
    "name": "trackExists",
    "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }],
    "stateMutability": "view",
    "type": "function"
  }
];

let contract;

const initializeContract = async () => {
  if (!window.ethereum) {
    alert("MetaMask is not installed. Please install it to use this feature.");
    return;
  }

  if (!contract) {
    const provider = new ethers.BrowserProvider(window.ethereum);
    await provider.send("eth_requestAccounts", []);
    const signer = await provider.getSigner();
    contract = new ethers.Contract(SMART_CONTRACT_ADDRESS, SMART_CONTRACT_ABI, signer);
  }
};

const createTrackOnBlockchain = async (trackId) => {
  await initializeContract();

  try {
    const trackExists = await contract.trackExists(trackId);
    if (trackExists) {
      console.log("Track already exists");
      return;
    }

    const tx = await contract.logTrackCreation(trackId);
    console.log(`Transaction hash (creation): ${tx.hash}`);
    const receipt = await tx.wait(); // Wait for the transaction to be mined
    console.log(`Track creation mined in block: ${receipt.blockNumber}`);
    return receipt;
  } catch (error) {
    console.error('Error creating track on blockchain:', error);
    throw error;
  }
};

const logTrackAccessOnBlockchain = async (trackId) => {
  await initializeContract();

  try {
    const tx = await contract.logTrackAccess(trackId);
    console.log(`Transaction hash (access): ${tx.hash}`);
    const receipt = await tx.wait(); // Wait for the transaction to be mined
    console.log(`Track access mined in block: ${receipt.blockNumber}`);
    return receipt;
  } catch (error) {
    console.error('Error logging track access on blockchain:', error);
    throw error;
  }
};

const getTrackInfo = async (trackId) => {
  await initializeContract();

  try {
    const trackInfo = await contract.getTrackInfo(trackId);
    console.log(`Track Creator: ${trackInfo.creator}`);
    console.log(`Track Timestamp: ${trackInfo.timestamp}`);
    return trackInfo;
  } catch (error) {
    console.error('Error getting track info:', error);
    throw error;
  }
};

export { createTrackOnBlockchain, logTrackAccessOnBlockchain, getTrackInfo };
